import {translator} from './translator';
import {onDocumentReady} from '../utils/dom/onDocumentReady';

onDocumentReady(() => {
    const elements = document.querySelectorAll('[data-translations-for-entry]');

    for (const element of elements) {
        const language = element.dataset.language;
        const translations = JSON.parse(element.textContent);

        translator.addTranslations({[language]: translations});
    }
});
